
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/shipping",
      function () {
        return require("private-next-pages/article/shipping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/shipping"])
      });
    }
  